import { generateBaselineWorkflow } from "./generateBaselineWorkflow";

const ASSESSMENT_KINDS = new Set([
  "MultipleChoice",
  "TrueFalse",
  "MultipleAnswer",
  "FillInBlank",
  "DragDrop",
  "Matching",
  "Ordering",
]);

export function planTrainingBaseline(navItemsById, boxesById, pluginToolbarsById) {
  const perSection = {};
  const stats = {
    sections: 0,
    sectionsNeedingWorkflow: 0,
    triggers: 0,
    assessments: 0,
    hotspots: 0,
  };

  const sections = Object.values(navItemsById).filter((n) => n && n.type === "section");
  for (const section of sections) {
    stats.sections += 1;
    const isEmpty =
      !section.workflow ||
      !Array.isArray(section.workflow.triggers) ||
      section.workflow.triggers.length === 0;
    if (!isEmpty) {
      perSection[section.id] = null;
      continue;
    }
    const wf = generateBaselineWorkflow(section, navItemsById, boxesById, pluginToolbarsById);
    perSection[section.id] = wf;
    stats.sectionsNeedingWorkflow += 1;
    stats.triggers += wf.triggers.length;

    for (const sceneId of section.children || []) {
      const scene = navItemsById[sceneId];
      if (!scene) continue;
      for (const boxId of scene.boxes || []) {
        const tb = pluginToolbarsById[boxId] || {};
        if (ASSESSMENT_KINDS.has(tb.pluginId)) stats.assessments += 1;
        if (tb.pluginId === "HotspotImages") {
          const marks = (tb.state && tb.state.marks) || [];
          if (
            marks.some(
              (m) => m && m.connection && (m.connectMode === "existing" || m.connectMode === "new")
            )
          ) {
            stats.hotspots += 1;
          }
        }
      }
    }
  }

  return { perSection, stats };
}
